import React from 'react'
import PropTypes from 'prop-types'

import cn from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import { Button } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'

const useStyles = makeStyles((theme) => ({
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(-180deg)',
  },
}))

const Toggle = ({ collapsed, collapsedText, expandedText, withIcon, onClick }) => {
  const classes = useStyles()
  return (
    <Button
      color="primary"
      onClick={onClick}
      endIcon={
        withIcon ? (
          <FontAwesomeIcon
            icon={faChevronUp}
            size="sm"
            className={cn(classes.expand, { [classes.expandOpen]: collapsed })}
          />
        ) : null
      }
    >
      {collapsed ? collapsedText : expandedText}
    </Button>
  )
}

Toggle.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  collapsedText: PropTypes.string,
  expandedText: PropTypes.string,
  withIcon: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}

Toggle.defaultProps = {
  collapsedText: 'Show More',
  expandedText: 'Show Less',
  withIcon: true,
}

export default Toggle
